import { getOrCreateThread as apiGetOrCreateThread } from 'APP/model/group/groupModel';
import { Group } from 'APP/store/Groups/Group';
import { Thread } from 'APP/store/Groups/Thread';
import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';
import Entities from 'STORE';

export async function getOrCreateThread(message: ChatMessage): Promise<Group | null> {
  let group = null;

  if (message.threadId) {
    group = Entities.GroupsStore.getGroupById(message.threadId);
  }

  if (!group) {
    try {
      const response = await apiGetOrCreateThread({
        groupId: message.groupId,
        messageId: message.id,
      });

      Entities.GroupsStore.merge([response]);
      group = Entities.GroupsStore.getGroupById(response.groupResponse.id);
    } catch (error) {
      return null;
    }
  }

  if (group instanceof Thread) {
    group.setThreadInfo({
      groupId: message.groupId,
      messageId: message.id,
    });
  }

  return group;
}
